(function(angular){
	'use strict';
	
	angular
		.module('viewPlanModule')
		.controller('AdvancedPlans', [
			'globalConfig',
			'orderFormFactory',
			'planFactory',
			'ServiceLevelFactory',
			'urlFactory',
			AdvancedPlansFunction
		]);
	
	function AdvancedPlansFunction(
		globalConfig,
		orderFormFactory,
		planFactory,
		ServiceLevelFactory,
		urlFactory
	){
		var advancedPlans = this;

		advancedPlans.changePlan = function(plan) {
			advancedPlans.selectedGoal = plan;
		};

		advancedPlans.handleInvestmentStrategySelection = function(investmentStrategy, investmentStrategySlug) {
			if(angular.isUndefined(advancedPlans.serviceLevel) || advancedPlans.serviceLevel === 'CORE') {
				ServiceLevelFactory.getRiaPlanByStrategyAndType(investmentStrategy, 'STANDARD')
					.then(function(riaPlanId) {
						orderFormFactory.submitOrderForm(riaPlanId, advancedPlans.serviceLevel).then(function() {
							urlFactory.redirect('/reits/checkout/start');
						});
					});
			} else if(advancedPlans.serviceLevel === 'ADVANCED') {
				urlFactory.redirect('/investments/core-plans/' + investmentStrategySlug + '/view-plan-variants');
			}
		};

		advancedPlans.$onInit = function(){
			angular.extend(advancedPlans, globalConfig);

			advancedPlans.planNames = ['Supplemental Income', 'Balanced Investing', 'Long-Term Growth'];

			planFactory.getPlanData(['STANDARD']).then(function(response){
				advancedPlans.plans = response.data;
				advancedPlans.selectedGoal = 'Balanced Investing';
				advancedPlans.amount = 10000;
			});
		};
	}
})(window.angular);